<template>
  <div>
    <slot :update-token="updateToken"></slot>
    
    <div class="row mt-25">
      <div class="col s12 center-align">
        <button 
          @click="updateCard" 
          v-show="!showPending" 
          class="btn-large" 
          :disabled="!cardToken"
        >
          Update Payment Method
        </button>
      </div>
    </div>
    
    <center v-show='showPending' class='grey-text mt-25'>
      <i class="fas fa-spinner fa-spin"></i> Processing...
    </center>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    paymentEventId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showPending: false,
      cardToken: null
    }
  },
  methods: {
    updateCard() {
      if (!this.cardToken) {
        this.notifyError("Please enter card details")
        return
      }

      this.showPending = true

      this.$apollo.mutate({
        mutation: gql`mutation ($paymentEventId: ID!, $token: String!) {
          updatePaymentEventCard(input: { paymentEventId: $paymentEventId, token: $token }) {
            paymentEvent {
              deprecatedId
            }
            message
            errors
          }
        }`,
        variables: {
          paymentEventId: this.paymentEventId,
          token: this.cardToken
        }
      }).then(result => {
        if(result.data.updatePaymentEventCard.errors.length > 0) {
          this.showPending = false
          this.notifyError(result.data.updatePaymentEventCard.errors[0])
        } else {
          this.notifySuccess(result.data.updatePaymentEventCard.message)
          // Redirect to payment event details page
          window.location.href = `/merchant/payment_events/${result.data.updatePaymentEventCard.paymentEvent.deprecatedId}`
        }
      }, error => {
        this.showPending = false
        this.gqlErrorHandler(error)
      })
    },
    updateToken(tokenData) {
      this.cardToken = tokenData.token
    }
  }
}
</script>
